import { Article } from '@generated'
import { cn } from '@lib/cn'
import { FC } from 'react'
import { Heading } from './ui/Heading'
import { Text } from './ui/Text'

type Props = {
  data: Article
}

const excludeAttributeIds = [57, 31]

const ProductProperties: FC<Props> = ({ data }) => {
  const filteredProperties = data?.articleAttributes?.filter(
    (item) => !excludeAttributeIds.includes(item?.attributeID || 0),
  )

  return (
    <section
      className={cn(
        'mx-auto !w-full !max-w-[1140px] columns-1 bg-rolexBlack px-6 py-12 text-white',
        'md:mt-[5vw] md:!w-[calc(100%-3rem)] md:columns-2 md:bg-transparent md:px-0 md:py-0 md:text-rolexBlack',
        'xl:!w-[calc(100%-5.5rem)]',
      )}
    >
      <div>
        {filteredProperties?.map((item) => (
          <div className="mb-4 break-inside-avoid-column lg:mb-8" key={item?.attributeID}>
            <Heading variant="small-title" className="mb-0 text-inherit">
              {item?.attributeName?.toUpperCase()}
            </Heading>
            <Text variant="regular" className="text-inherit">
              {item?.attributeValue}
            </Text>
          </div>
        ))}
      </div>
    </section>
  )
}

export default ProductProperties
